import React, { Children, cloneElement, Component } from 'react';
import classNames from 'classnames';
import TimelineItem from './TimelineItem';
import Spin from '../spin';
import ConfigContext from '../config-provider/ConfigContext';
import { Size } from '../_util/enum';
export default class Timeline extends Component {
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { prefixCls: customizePrefixCls, spinPrefixCls, children, pending = null, pendingDot, className, reverse, ...restProps } = this.props;
        const { getPrefixCls } = this.context;
        const pendingNode = typeof pending === 'boolean' ? null : pending;
        const prefixCls = getPrefixCls('timeline', customizePrefixCls);
        const classString = classNames(prefixCls, {
            [`${prefixCls}-pending`]: !!pending,
            [`${prefixCls}-reverse`]: !!reverse,
        }, className);
        const pendingItem = pending ? (React.createElement(TimelineItem, { prefixCls: prefixCls, pending: !!pending, dot: pendingDot || React.createElement(Spin, { prefixCls: spinPrefixCls, size: Size.small }) }, pendingNode)) : null;
        const timeLineItems = reverse
            ? [pendingItem, ...Children.toArray(children).reverse()]
            : [...Children.toArray(children), pendingItem];
        // Remove falsy items
        const truthyItems = timeLineItems.filter(item => !!item);
        const itemsCount = Children.count(truthyItems);
        const lastCls = `${prefixCls}-item-last`;
        const items = Children.map(truthyItems, (ele, idx) => cloneElement(ele, {
            className: classNames([
                ele.props.className,
                (!reverse && !!pending)
                    ? (idx === itemsCount - 2) ? lastCls : ''
                    : (idx === itemsCount - 1) ? lastCls : '',
            ]),
        }));
        return (React.createElement("ul", Object.assign({}, restProps, { className: classString }), items));
    }
}
Timeline.displayName = 'Timeline';
Timeline.Item = TimelineItem;
